import { create } from "zustand";

// LQC-2173 - ONE interval for the whole app, driving every expiry countdown in
// every blotter. Do NOT add a timer per cell.
//
// Subscribers must select a value that only changes when their display changes
// (see returnExpiryStepKey), never nowMs itself. Selecting nowMs would
// re-render every subscriber every second and undo the entire design: a cell
// counting down in days would repaint 86,400 times a day to show the same text.

type State = {
  nowMs: number;
};

const clockStore = create<State>(() => ({
  nowMs: Date.now(),
}));

const TICK_MS = 1000;
let intervalId: ReturnType<typeof setInterval> | null = null;

// Idempotent - safe to call from more than one mount point.
export function startClock(): void {
  if (intervalId !== null) return;
  intervalId = setInterval(() => {
    // Wall clock, never a decrementing counter: laptop sleep, background-tab
    // throttling and a missed tick all self-heal instead of drifting.
    clockStore.setState({ nowMs: Date.now() });
  }, TICK_MS);
}

export function stopClock(): void {
  if (intervalId === null) return;
  clearInterval(intervalId);
  intervalId = null;
}

export function isClockRunning(): boolean {
  return intervalId !== null;
}

export default clockStore;
